import { render, staticRenderFns } from "./BeneficiaryEmergencyContact.vue?vue&type=template&id=3462fdde&"
import script from "./BeneficiaryEmergencyContact.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryEmergencyContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports